<div
  class="legend-container"
  [style]="expanded && isSmallDevice ? 'max-width:350px;' : ''"
>
  <div
    class="header"
    [style]="expanded ? 'margin-bottom:20px;' : 'margin-bottom:0px;'"
  >
    <p class="header-title">Precio por Sección</p>
    <span
      class="material-symbols-outlined expand-btn"
      style="cursor:pointer;"
      (click)="onExpandToggle()"
      >{{ !expanded ? 'arrow_circle_up' : 'arrow_circle_down' }}</span
    >
  </div>

  <div class="pricing-list" *ngIf="expanded">
    <div class="pricing-item" *ngFor="let item of items">
      <div class="section-info">
        <div
          class="color-indicator"
          [style]="'background-color: ' + item.color"
        ></div>
        <span class="section-name">{{ item.name }}</span>
      </div>
      <span class="price">RD${{ item.price }}</span>
    </div>
  </div>
</div>
